import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { toastHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";

export const leadStatusApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLeadStatus: builder.query({
      query: ({ id }) => ({
        url: `lead-status/${id}`,
      }),
      providesTags: ["LeadStatus"],
    }),
    getLeadStatuses: builder.query({
      query: () => ({
        url: `lead-status?query=all`,
      }),
      providesTags: ["LeadStatusAll"],
    }),
    getLeadStatusesPaginated: builder.query({
      query: (arg) => {
        const query = queryGenerator(arg);
        return {
          url: `lead-status?${query}`,
        };
      },
      providesTags: ["LeadStatuses"],
    }),

    addLeadStatus: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `lead-status`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Lead Status added successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["LeadStatuses", "LeadStatusAll"],
    }),

    deleteLeadStatus: builder.mutation({
      query: ({ id }) => ({
        url: `lead-status/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Deleted Lead Status successfully", "warning");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["LeadStatus", "LeadStatuses", "LeadStatusAll"],
    }),

    updateLeadStatus: builder.mutation({
      query: ({ id, values }) => ({
        url: `lead-status/${id}`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: values,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Lead Status updated successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["LeadStatus", "LeadStatuses", "LeadStatusAll"],
    }),
  }),
});

export const {
  useGetLeadStatusQuery,
  useGetLeadStatusesQuery,
  useAddLeadStatusMutation,
  useDeleteLeadStatusMutation,
  useUpdateLeadStatusMutation,
  useGetLeadStatusesPaginatedQuery,
} = leadStatusApi;

